import React, { useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CommonButton from "../../../components/commonButton";
import { Upload04Icon } from "../../../assets/icons";
import { formatMomentDate } from "../../../utils/dateHelper";
import StatusChip from "../../../components/statusChip/StatusChip";
import { BankIcons } from "../../../utils/otherHelopers";
import CommonVerifyModal from "../../../components/verify-modal/VerifyModal";
import { FilterBtn } from "../../../components/commonButton/btns";
import CustomTable from "../../../components/table/CustomTable";
import { TableSearch } from "../../../components/form/Fields";
import { Eye } from "lucide-react";

const ListSection = ({
  data,
  searchTerm,
  setSearchTerm,
  setCurrentPage,
  handleExportAllUsersList,
  isLoading,
  pagination,
}) => {
  let isFilterActive = false;
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const columns = useMemo(() => [
    {
      id: "actions",
      header: "ACTIONS",
      cell: (_, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-view">View</Tooltip>}
        >
          <button
            className="me-2 text-primary bg-transparent border-0"
            onClick={(e) => {
              setSelectedUser(row);
              setShowViewModal(true);
              e.stopPropagation();
            }}
          >
            <Eye size={20} />
          </button>
        </OverlayTrigger>
      ),
    },
    {
      id: "name",
      header: "NAME",
      accessor: 'profile.name'
    },
    {
      id: "mobile_number",
      header: "MOBILE NUMBER",
      accessor: "mobile_number",
    },
    {
      id: "email",
      header: "EMAIL",
      accessor: "email",
    },
    {
      id: "designation",
      header: "DESIGNATION",
      accessor: "profile.designation",
    },
    {
      id: "bank",
      header: "BANK",
      accessor: "profile.bank.bank_name",
      cell: (v) => v ? (
        <div className="text-start">
          {BankIcons(v)}{" "}
          {v}
        </div>
      ) : "-",
    },
    {
      id: "branch",
      header: "BRANCH",
      accessor: 'profile.branch',
      cell: (v) => v ? v.branch_city : "-",
    },
    {
      id: "created_at",
      header: "CREATED AT",
      accessor: 'created_at',
      cell: (v) => (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <span>{formatMomentDate(v, "DD MMM YYYY")}</span>
          <span>{formatMomentDate(v, "hh:mm A")}</span>
        </div>
      ),
    },
    {
      id: "status",
      header: "STATUS",
      accessor: 'status',
      cell: (v) => v ? (
        <StatusChip
          pill
          bg={
            v === "pending"
              ? "warning"
              : v === "approved"
                ? "success"
                : v === "rejected"
                  ? "danger"
                  : ""
          }
          title={v}
          className="text-capitalize"
        />
      ) : "-",
    },
  ], []);

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <div className="d-flex align-items-center gap-2">
          <TableSearch value={searchTerm}
            placeholder="Search"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }} />
          <FilterBtn active={isFilterActive} onClick={() => { }} />
        </div>

        <div className="action-buttons-container">
          <CommonButton
            icon={<Upload04Icon strokeWidth="2.0" />}
            className="me-2"
            title="Export"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleExportAllUsersList();
            }}
          />
        </div>
      </div>

      <CustomTable
        data={data || []}
        columns={columns}
        loading={isLoading}
        emptyMessage="No verification requests found"
        keyField="id"
        disabledAction={true}
        pagination={pagination}
      />

      {showViewModal && selectedUser && (
        <CommonVerifyModal
          isOpen={showViewModal && Boolean(selectedUser)}
          onClose={() => setShowViewModal(false)}
          title="Verify Document"
          imageSrc={"/assets/images/aadhar-card.png"}
          fields={[
            {
              label: "Document Number",
              value: selectedUser?.profile?.name || "-",
              disabled: true,
            },
            {
              label: "Issue Date",
              value: selectedUser?.profile?.name || "-",
              disabled: true,
            },
          ]}
          showApprove={true}
          showReject={true}
          size="lg"
          className="verify-modal"
        />
      )}
    </>
  );
};

export default ListSection;
